export const LINKS = [
  {
    text: "Fabric Organization Labels - FREE",
    url: "https://docs.google.com/spreadsheets/d/1p2Q2L4RyBwNIR5NDuqjZKW_I67wTwVqDxkSYGSdrMTw/edit?usp=sharing",
    external: true
  },
  {
    text: "Edges and Edges - use ABBY10",
    url: "https://www.edgeandedges.com/?ref=ABBY10",
    external: true
  },
  {
    text: "DIY Shirred Shoulder Tie Dress",
    url: "https://www.themakerstudio.ca/shirred-shoulder-tie-dress-diy/",
    external: true
  }
];
